import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit, Signal, ViewChild, WritableSignal } from '@angular/core';
import { ProjectInfrastructureService } from '@app/shared/services/project-infrastructure.service';
import { Project } from 'lfx-pcc';
import { AccordionModule } from 'primeng/accordion';
import { TreeNode } from 'primeng/api';
import { ChipModule } from 'primeng/chip';
import { Tree, TreeModule } from 'primeng/tree';

@Component({
  selector: 'lfx-projects-filter',
  standalone: true,
  imports: [CommonModule, TreeModule, AccordionModule, ChipModule],
  templateUrl: './projects-filter.component.html',
  styleUrl: './projects-filter.component.scss',
})
export class ProjectsFilterComponent implements OnInit {
  @ViewChild('tree') public tree: Tree;

  public project: WritableSignal<Partial<Project>>;
  public projects: WritableSignal<TreeNode[]>;
  public selectedProjects: WritableSignal<TreeNode[]>;
  public selectedProjectsCount: Signal<number> = computed(() => this.selectedProjects().length);

  private itxService: ProjectInfrastructureService = inject(ProjectInfrastructureService);

  public constructor() {
    this.project = this.itxService.project;
    this.selectedProjects = this.itxService.selectedProjects;
    this.projects = this.itxService.projects;
  }

  public ngOnInit(): void {}

  public get projectsSelected(): boolean {
    return this.selectedProjects().length > 0;
  }

  public onNodeSelect(event: TreeNode<any> | TreeNode<any>[] | null | undefined): void {
    this.selectedProjects.set(event as TreeNode[]);
  }

  public onToggleSelectAll(): void {
    if (this.projectsSelected) {
      // Clear all selections
      const current = this.tree.selection() as TreeNode[];
      this.tree.selection.set(current.length ? [] : this.projects());
      this.selectedProjects.set(this.tree.selection() as TreeNode[]);
    } else {
      this.itxService.selectAllProjects(this.itxService.project());
    }
  }
}
